// extracted by mini-css-extract-plugin
module.exports =  {"agenda":"agenda-HBmtw","day":"day-zH7iC","program":"program-fzin6","time":"time-lipF3","thumbnail":"thumbnail-e27O3","title":"title-WPgjF","duration":"duration-qRgFC"};